'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeSizeProp = exports.computeShapeProp = undefined;

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Backwards compatibility for UIComponents/avatar/UIAvatar (HubSpot/UIComponents#4738)

/* backcompat old `shape` prop values */
var computeShapeProp = exports.computeShapeProp = function computeShapeProp(shape) {
  if (shape === 'square') {
    _devLogger2.default.warn({
      message: 'UIAvatar: `shape="square"` is deprecated. Use `shape="default"` instead.',
      key: 'UIAvatar: deprecated `shape="square"` prop value'
    });
    return 'default';
  }
  return shape;
};

// aliases for old `size` prop values
var sizePropAliases = {
  'extra-small': 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  'extra-large': 'xl'
};

/** backcompat old UIAvatar `size` prop values */
var computeSizeProp = exports.computeSizeProp = function computeSizeProp(rawSizeProp) {
  var size = sizePropAliases[rawSizeProp] || rawSizeProp;
  if (size !== rawSizeProp) {
    _devLogger2.default.warn({
      message: 'UIAvatar: `size="' + rawSizeProp + '"` is deprecated. Use `size="' + size + '"` instead.',
      key: 'UIAvatar: deprecated `size="' + rawSizeProp + '"` prop value'
    });
  }
  return size;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-1.1461/js/lib/compat.js
// module id = 268
// module chunks = 0